// extracted by mini-css-extract-plugin
export var buttonwrapper = "SectionSignPostCardCarousel-module--buttonwrapper--c0b93";
export var introtext = "SectionSignPostCardCarousel-module--introtext--24257";
export var pagination = "SectionSignPostCardCarousel-module--pagination--0c469";
export var signpostcardcarouselinner = "SectionSignPostCardCarousel-module--signpostcardcarouselinner--5f774";
export var swiper = "SectionSignPostCardCarousel-module--swiper--e8c08";
export var swiperwrapper = "SectionSignPostCardCarousel-module--swiperwrapper--83e8c";
export var title = "SectionSignPostCardCarousel-module--title--73cc8";
export var titlewrapper = "SectionSignPostCardCarousel-module--titlewrapper--7ea19";